import classNames from "classnames";
import React from "react";
import { buildBackgroundGradientClassName } from "./BackgroundGradient";

export const GradientSpacer: React.FC = () => {
  return (
    <div
      className={classNames(
        "h-16 w-full",
        buildBackgroundGradientClassName("Short", "Hyacinth"),
      )}
    ></div>
  );
};
